import React from "react";
const SettingsContext = React.createContext("totdSettings");
function useSettings() {
  const context = React.useContext(SettingsContext);
  if (context === undefined) {
    throw new Error(`useSettings must be used within a SettingsProvider`);
  }
  return context;
}

export { SettingsContext, useSettings };
